import Modal from '@/components/Modal';
import { SWS_SUPPORT } from '@/constants';
import { format } from 'date-fns';
import { Column, Row } from '@simplywallst/ui-core';
import Media from 'react-media';
import { useTheme } from '@simplywallst/ui-core';
import { useCloudflareImage, getStaticUrl } from '@/hooks/useCloudflareImage';

interface Props {
  userName: string;
  userPeriodEndDate: number;
  handleCloseModal: () => void;
}

export const BillingInfoModal = ({
  userName,
  userPeriodEndDate,
  handleCloseModal,
}: Props) => {
  const theme = useTheme();
  const unlimitedBearSrc = useCloudflareImage({
    src: getStaticUrl('unlimited-bear.png'),
  });
  return (
    <Modal
      title="About your subscription"
      onPrimaryClick={() => {
        handleCloseModal();
      }}
      primaryLabel="OKAY"
      onSecondaryClick={() => handleCloseModal()}
      onClose={() => handleCloseModal()}
      hideSecondary
    >
      <>
        <Row>
          <Media
            query={{ minWidth: theme.mdMinRaw }}
            render={() => (
              <Column colMd={4} col={12}>
                <img src={unlimitedBearSrc} alt="bear-illustration" />
              </Column>
            )}
          ></Media>
          <Column colMd={8} col={12}>
            <p>
              <b>{`Hey ${userName},`}</b>
            </p>
            <p>
              We wanted to provide some further clarification about your
              subscription since the rollout of our new plans.
            </p>
            <p>
              As a previously paid Simply Wall St subscriber we have upgraded
              you to our new Unlimited plan <b>at no extra cost.</b>
            </p>
            <p>
              <span>
                {`This means that your future renewals starting on ${format(
                  userPeriodEndDate,
                  'MMM dd, yyyy'
                )} `}
              </span>
              <span>
                will be charged at the same amount (not including any discounts
                applied upon subscribing).
              </span>
            </p>
            <p>
              <span>If you have any questions, please don’t hesitate to </span>
              <a
                href={`${SWS_SUPPORT}/requests/new`}
                target="_blank"
                rel="noopener noreferrer"
              >
                contact our friendly support team.
              </a>
            </p>
            <p>
              Happy investing!
              <br />
              The team at Simply Wall St
            </p>
          </Column>
        </Row>
      </>
    </Modal>
  );
};
